import styled from "@emotion/styled";
import * as React from "react";

import { Icon, IconsEnum } from "components/icon";

const StyledLockIcon = styled(Icon)`
  margin-left: 5px;
  fill: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
`;

export const LockIcon: React.FC = () => (
  <StyledLockIcon inline name={IconsEnum.ClosedLock} width="16px" height="16px" />
);
